var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAssetControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.874 21c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.052 28H8.873c-2.206 0-4-1.794-4-4s1.794-4 4-4h14.18c2.205 0 4 1.794 4 4s-1.795 4-4 4m0-10H8.872c-3.308 0-6 2.69-6 6 0 3.309 2.692 6 6 6h14.18c3.308 0 6-2.691 6-6 0-3.31-2.692-6-6-6M23.052 11c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.874 4h14.179c2.206 0 4 1.794 4 4s-1.794 4-4 4H8.873c-2.205 0-4-1.794-4-4s1.795-4 4-4m0 10h14.18c3.308 0 6-2.691 6-6 0-3.31-2.692-6-6-6H8.873c-3.308 0-6 2.69-6 6 0 3.309 2.692 6 6 6"
  })))));
}

export default SvgIconAssetControl;